import { Component, Renderer2, ChangeDetectorRef, Input } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { TaxLinesBus } from '@app/cp/shared/models/TaxLinesBus';
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { BaseMessageInfo } from '../../../models/BaseMessageInfo';
import { GGItem } from '../../../models/GGItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'tax-lines-edit',
    templateUrl: './tax-lines-edit.component.html',
    styleUrls: ['./tax-lines-edit.component.scss']
})
export class TaxLinesEditComponent extends BaseGridEditLineComponent<TaxLinesBus, null, CustomerService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: CustomerService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.pageSize = 10;
        this.className = "TaxLinesBus";
        this.saveMode = SaveMode.individual;
        this.appCode = "TaxLineEdit";
        this.readOnly = false;
        this.callSaveIndividualInsteadOfSave = true;
    }
    pageSize = 10;

    createForm() {
        this.editForm = new UntypedFormGroup({
            'taxLineId': new UntypedFormControl(),
            'companyId': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
            'rate': new UntypedFormControl(),
            'taxLineName': new UntypedFormControl('', Validators.required),
            'supplierId': new UntypedFormControl('', Validators.required),
            'isTaxLabor': new UntypedFormControl(),
            'isTaxMaterial': new UntypedFormControl(),
            'isTaxOther': new UntypedFormControl(),
            'taxCodeTaxLineXREFId': new UntypedFormControl(),
            'supplierName': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserid': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'qbid': new UntypedFormControl(),
            'qbeditSequenceId': new UntypedFormControl()
        });
        this.disableCpSearchDialog();
    }

    setForm() {
        this.editForm.patchValue({
            taxLineId: this.selectedData.taxLineId,
            companyId: this.selectedData.companyId,
            isActive: this.selectedData.isActive,
            rate: this.selectedData.rate,
            taxLineName: this.selectedData.taxLineName,
            supplierId: this.selectedData.supplierId,
            isTaxLabor: this.selectedData.isTaxLabor,
            isTaxMaterial: this.selectedData.isTaxMaterial,
            isTaxOther: this.selectedData.isTaxOther,
            taxCodeTaxLineXREFId: this.selectedData.taxCodeTaxLineXREFId,
            supplierName: this.selectedData.supplierName,
            insertDt: this.selectedData.insertDt,
            insertUserid: this.selectedData.insertUserid,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            qbid: this.selectedData.qbid,
            qbeditSequenceId: this.selectedData.qbeditSequenceId
        });
    }
    suppliersInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }

    get suppliers(): GGItem[] {
        let results: GGItem[] = [];
        if (this.hasReferenceData) {
            results = this.referenceData.suppliers; //.filter(s => s.flag === false);
        }
        return results;
    }

    public _active: boolean = false;
    @Input() set active(value: boolean) {
        if (value != this._active) {
            this._active = value;
        }
    }
    get active() {
        return this._active;
    }

    createNewSaveVersion(className: string, data: any = null): any {
        let busObj: TaxLinesBus = super.createNewSaveVersion(className, data);
        busObj = this.setFromReferenceData(busObj);
        busObj.setBeforeSave();
        return busObj;
    }
    setFromReferenceData(data: TaxLinesBus) {
        data.supplierName = this.referenceData.getSupplierName(data.supplierId);
        return data;
    }

    saveIndividual(dataObj: TaxLinesBus): Promise<BaseMessageInfo> {
        let busObj: TaxLinesBus = this.createNewSaveVersion("TaxLinesBus", dataObj);
        var isAdded = busObj.isAdded;

        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveTaxLine(busObj).toPromise().then((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let newDataObj: TaxLinesBus = new TaxLinesBus(info.primaryReturn);
                    newDataObj = this.setFromReferenceData(newDataObj);
                    retInfo.primaryReturn = newDataObj;
                    this.notify(this.appCode + " Saved Successfully!");
                }
                else {
                    retInfo.message = "Error Saving"
                    retInfo.saveError = true;
                    this.saveError(null, retInfo.message);
                }
                this.dataLoading = false;
                resolve(retInfo);
            });
        });
    }
    deleteIndividual(data: TaxLinesBus) {
            if (data.hasId) {
                this.svc_data.deleteTaxLine(data.taxLineId).subscribe((dataObj: BaseMessageInfo) => {
                    if (!dataObj.saveError) {
                        let delDataObj: TaxLinesBus = new TaxLinesBus(data);
                        this.deleteSuccess(delDataObj);
                        this.removeLocal(delDataObj);
                        this.cd.detectChanges();
                        //this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                    }
                    else {
                        this.deleteError(data, dataObj.message);

                    }
                });
            }
            else {
                this.closeEditor();
            }
    }

    doneEvent() {
        this.close(false);
    }
    close(e: any) {
        super.close(e);
    }

}
